import * as React from "react";
import { JSONStringify } from "json-with-bigint";
import { LinkContainer, ClipboardButton } from "components/common";
import Routes from "routing/Routes";
import { Button, ButtonGroup, DropdownButton, MenuItem } from "components/bootstrap";
import SurroundingSearchButton from "components/search/SurroundingSearchButton";
import usePluginEntities from "hooks/usePluginEntities";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import MessagePermalinkButton from "views/components/common/MessagePermalinkButton";
import useFeature from "hooks/useFeature";
import MessageEditFieldConfigurationAction from "./fields/MessageEditFieldConfigurationAction";
const TestAgainstStreamButton = ({
  streams,
  index,
  id
}) => {
  const sendTelemetry = useSendTelemetry();
  const sendEvent = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_MESSAGE_TABLE_TEST_AGAINST_STREAM, {
      app_section: "search-message-table",
      app_action_value: "seach-message-table-test-against-stream"
    });
  };
  const streamList = streams.map((stream) => {
    if (stream.is_default) {
      return /* @__PURE__ */ React.createElement(MenuItem, { key: stream.id, onClick: () => sendEvent(), disabled: true, title: "Cannot test against the default stream" }, stream.title);
    }
    return /* @__PURE__ */ React.createElement(LinkContainer, { key: stream.id, to: Routes.stream_edit_example(stream.id, index, id) }, /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => sendEvent() }, stream.title));
  });
  return /* @__PURE__ */ React.createElement(DropdownButton, { pullRight: true, bsSize: "small", title: "Test against stream", id: "select-stream-dropdown" }, streamList && !streamList.isEmpty() ? streamList.toArray() : /* @__PURE__ */ React.createElement(MenuItem, { header: true }, "No streams available"));
};
const usePluggableMessageActions = (id, index) => {
  const pluggableMenuActions = usePluginEntities("views.components.widgets.messageTable.messageActions");
  return pluggableMenuActions.filter((actions) => actions.useCondition ? !!actions.useCondition() : true).map(({ component: PluggableMenuAction, key }) => /* @__PURE__ */ React.createElement(PluggableMenuAction, { key, id, index }));
};
const MessageActions = ({
  index,
  id,
  fields,
  decorationStats,
  disabled,
  disableSurroundingSearch,
  disableTestAgainstStream,
  showOriginal,
  toggleShowOriginal,
  streams
}) => {
  const pluggableActions = usePluggableMessageActions(id, index);
  const isFavoriteFieldsEnabled = useFeature("message_table_favorite_fields");
  if (disabled) {
    return /* @__PURE__ */ React.createElement(ButtonGroup, null);
  }
  const { timestamp, ...remainingFields } = fields;
  const surroundingSearchButton = disableSurroundingSearch || /* @__PURE__ */ React.createElement(SurroundingSearchButton, { id, timestamp: String(timestamp), messageFields: remainingFields });
  const showChanges = decorationStats && /* @__PURE__ */ React.createElement(Button, { onClick: toggleShowOriginal, active: showOriginal }, "Show changes");
  return /* @__PURE__ */ React.createElement(ButtonGroup, null, showChanges, /* @__PURE__ */ React.createElement(MessagePermalinkButton, { messageIndex: index, messageId: id }), pluggableActions, /* @__PURE__ */ React.createElement(ClipboardButton, { title: "Copy ID", text: id, bsSize: "small" }), /* @__PURE__ */ React.createElement(ClipboardButton, { title: "Copy message", bsSize: "small", text: JSONStringify(fields, null, 2) }), surroundingSearchButton, disableTestAgainstStream ? null : /* @__PURE__ */ React.createElement(TestAgainstStreamButton, { streams, id, index }), isFavoriteFieldsEnabled && /* @__PURE__ */ React.createElement(MessageEditFieldConfigurationAction, null));
};
export default MessageActions;
